import React, { Component } from 'react';

export default class OpenViduVideoComponent extends Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();

        this.state = {
            showFullScreen: false
        }

    }

    /*componentWillReceiveProps(props) {
        if (props && !!this.videoRef) {
            this.props.streamManager.addVideoElement(this.videoRef.current);
        }
    }*/
    _toggleFullScreen = () => {

        var documentElement = this.videoRef.current;
        const { showFullScreen } = this.state

        this.setState({ showFullScreen: !showFullScreen })
        // If fullscreen mode is active...	
        if (!showFullScreen) {
            // ...exit fullscreen mode
            // (Note: this can only be called on document)
            if (this.videoRef.exitFullscreen) this.videoRef.current.exitFullscreen();
            else if (this.videoRef.current.mozCancelFullScreen) this.videoRef.current.mozCancelFullScreen();
            else if (this.videoRef.current.webkitCancelFullScreen) this.videoRef.current.webkitCancelFullScreen();
            else if (this.videoRef.current.msExitFullscreen) this.videoRef.current.msExitFullscreen();
            documentElement.setAttribute('data-fullscreen', !!false);
        } else {
            // ...otherwise enter fullscreen mode
            // (Note: can be called on document, but here the specific element is used as it will also ensure that the element's children, e.g. the custom controls, go fullscreen also)
            if (documentElement.requestFullscreen) documentElement.requestFullscreen();
            else if (documentElement.mozRequestFullScreen) documentElement.mozRequestFullScreen();
            else if (documentElement.webkitRequestFullScreen) {
                // Safari 5.1 only allows proper fullscreen on the video element. This also works fine on other WebKit browsers as the following CSS (set in styles.css) hides the default controls that appear again, and 
                // ensures that our custom controls are visible:
                // figure[data-fullscreen=true] video::-webkit-media-controls { display:none !important; }
                // figure[data-fullscreen=true] .controls { z-index:2147483647; }
                documentElement.webkitRequestFullScreen();
            }
            else if (documentElement.msRequestFullscreen) documentElement.msRequestFullscreen();
            documentElement.setAttribute('data-fullscreen', !!true);
        }
    }

    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this)
        }
        if (this.props && !!this.videoRef) {
            this.props.streamManager.addVideoElement(this.videoRef.current);
        }
    }

    render() {
        return <video onClick={this._toggleFullScreen} autoPlay={true} ref={this.videoRef} />;
    }
}
